import { HvHostMap } from '@/connection/helpers';
import { getCloudfrontUrl } from './get-cloudfront-url';

type sizeParams = 'height' | 'width' | 'fit' | 'quality';
export type ResizeParams = { height?: number; width?: number; fit?: 'cover' | 'contain'; quality?: number };
export const resizedImage = (url?: string, size?: ResizeParams): string | undefined => {
  if (!url) return undefined;
  // do not resize svgs
  if (url.endsWith('.svg')) return getCloudfrontUrl(url);

  const params = new URLSearchParams();
  if (size) {
    for (const key in size) {
      if (size[key as sizeParams]) {
        params.set(key, String(size[key as sizeParams]));
      }
    }
  }

  // brandlive.io is the GCP estate. This tested VITE_BASE_URL for '.io', which
  // also matches brandtv-staging.io (EU) and sent EU builds to a US host.
  const hostname = import.meta.env.VITE_CLOUD_PROVIDER === 'gcp' ? 'brandlive.io' : 'brandlive.com';

  // old uploads or general assets
  url = url.replace(
    /https:\/\/brandlive-upload.s3-us-west-2.amazonaws.com|https:\/\/assets.brandlive.com/,
    `https://image-resizer.${hostname}/e3-image`
  );

  // fix production images pulled down to lower stages
  url = url.replace(
    /https:\/\/uploads.brandlive.com/,
    HvHostMap.imageResizer.split('.')[0] + '.brandlive.com/image-resizer'
  );

  // images in the current stage
  url = url.replace(/https:\/\/uploads.brandlive(-.*)?.(com|io)/, HvHostMap.imageResizer + '/image-resizer'); // New Uploads

  try {
    const urlObject = new URL(url);
    params.forEach((value, key) => {
      urlObject.searchParams.set(key, value);
    });

    return urlObject.toString();
  } catch {
    return url + `?${params.toString()}`;
  }
};
